(function () {
  'use strict';

  angular.module('app').component('tourList', tourList());

  function tourList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowItem: '&',
        defaultLanguage: '<',
        userLanguageCode: '<',
      },
      controller: TourListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/tours/tour-list/tour-list.component.html',
    };
  }

  TourListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'TourService',

    // Angular downgraded service
    'locationService',
  ];

  function TourListComponent(config, UtilService, AbilityService, TourService, locationService) {
    let vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_tour_accountadmin'),
      canUpdate: AbilityService.can('update_tour_accountadmin'),
      canDestroy: AbilityService.can('destroy_tour_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = TourService.getFilterCriteria();

    vm.activeStatus = config.ACTIVE;
    vm.inactiveStatus = config.INACTIVE;

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;
    vm.timeOptions = config.TIME_OPTIONS;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    vm.changeItemFeatured = changeItemFeatured;

    vm.searchLocations = (search) => {
      if (search.length < 2) {
        return;
      }

      let params = {
        get: 'active',
        by_name: search,
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      locationService.getLocations(params).subscribe((response) => {
        vm.locations = response;
      });
    };

    vm.clearLocations = () => {
      vm.locations = [];

      vm.UtilService.filterResult();
    };

    vm.popover = {
      templateUrl: 'options.html',
      open: function open(item) {
        vm.tourOptions = item.tour_options;
      },
    };

    function fetchResult() {
      // vm.filterCriteria['by_location_ids[]'] = ['5e96538353321a0c06f9758d', '5e96538353321a0c06f97592'];

      vm.loadingItems = true;
      TourService.getTours(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.locations = [];

      vm.filterCriteria = TourService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onShowItem({ item: item, mode: mode });
    }

    function deleteItem(item) {
      if (!vm.permissions.canDestroy) {
        return;
      }

      TourService.deleteTour(item, fetchResult);
    }

    function changeItemStatus(item) {
      if (!vm.permissions.canUpdate) {
        return;
      }

      TourService.changeTourStatus(item);
    }

    function changeItemFeatured(item) {
      TourService.changeTourFeatured(item);
    }
  }
})();

// Do not delete - Keep it for reference
/*

                        <!-- <search-dropdown
                            options="vm.data"
                            options-selected="vm.optionsSelected"
                            settings="vm.settings"
                            events="vm.events">
                        </search-dropdown> -->


       vm.data = [
            {
                id: 1,
                name: 'This is the first element element'
            },
            {
                id: 2,
                name: 'Two'
            },
            {
                id: 3,
                name: 'Three'
            },
            {
                id: 4,
                name: 'Four'
            },
            {
                id: 5,
                name: 'Five'
            },
            {
                id: 6,
                name: 'Six'
            },
            {
                id: 7,
                name: 'Seven'
            },
            {
                id: 8,
                name: 'Eight'
            },
            {
                id: 9,
                name: 'Nine'
            },
            {
                id: 10,
                name: 'Ten'
            }
        ];

        vm.optionsSelected = [];

        vm.settings = {
            label:        $translate.instant('LOCATION'),
            enableSearch: true,
            checkBoxes:   true,
            styleActive:  true
        };

        vm.events = {
            onOptionSelect: function(item) {
                console.log('onOptionSelect');

                console.log(vm.optionsSelected);
            },
            onOptionDeselect: function(item) {
                console.log('onOptionDeselect');

                console.log(vm.optionsSelected);
            }
        };*/
